import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "gtestudentvisa",
  inputs: [
    {
      name: "name",
      label: "Full Name",
      placeholder: "Ankita Chaudhary",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "contact",
      label: "Contact Information",
      placeholder: "",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "course_selected",
      label: "Course Selected",
      placeholder: "Mtech. in Artificial Intelligence",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "university_opted",
      label: "University/College Name",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "reason_to_choose_australia",
      label: "Why you choose Australia for this course",
      placeholder: "Mtech. in Artificial Intelligence",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 500,
      required: true,
    },
    {
      label: "Future Prospective",
      type: InputType.InputCluster,
      cols: 2,
      required: true,
      fields: [
        {
          name: "home_country",
          label: "Home Country",
          placeholder: "India",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description: "Please write your current country for best results.",
          required: true,
        },
        {
          name: "expected_salary",
          label: "Expected Salary",
          placeholder: "40k US dollars",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
          assistance: true,
          inputDependencies: ["course_selected"],
          helpType: "future_scope",
          required: true,
        },
        {
          name: "companies",
          label: "Companies",
          placeholder: "IBM Infosys Wipro",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 400,
          assistance: true,
          inputDependencies: ["course_selected"],
          helpType: "future_scope",
          required: true,
        },
        {
          name: "roles",
          label: "Posts",
          placeholder: "Software Developer",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 400,
          assistance: true,
          inputDependencies: ["course_selected"],
          helpType: "future_scope",
          required: true,
        },
      ],
    },
    {
      label: "Class 10 completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: true,
      fields: [
        {
          name: "class10_score",
          label: "Matriculation Marks",
          placeholder: "8.5 CGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //   "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "class10_yop",
          label: "Year of Passing",
          placeholder: "2018",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class10_school",
          label: "Matriculation School",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class10_board",
          label: "Matriculation Board",
          placeholder: "CBSE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Diploma completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "diploma_score",
          label: "Diploma Marks",
          placeholder: "8.5 CGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          //   description:
          //    "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "diploma_yop",
          label: "Year of Passing",
          placeholder: "2018",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "diploma_school",
          label: "From which institution you had completed diploma?",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "diploma_subject",
          label: "In which field you had completed diploma?",
          placeholder: "Computer Science",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Class 12 completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "class12_score",
          label: "Class 12 Marks",
          placeholder: "92%",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "class12_yop",
          label: "Class 12 Year of Passing",
          placeholder: "2020",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_school",
          label: "Class 12 School",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_board",
          label: "Class 12 Board",
          placeholder: "CBSE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_subject",
          label: "Class 12 Subjects",
          placeholder: "Non-Medical",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          //   description:
          //    "Mention the stream choosen after matriculation for e.g.-Arts,Commerce,Medical,Non-Medical etc.",
        },
      ],
    },
    {
      label: "Bachelors completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "bachelors_cgpa",
          label: "Bachelors Marks",
          placeholder: "8 SGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "bachelors_yop",
          label: "Year of Passing",
          placeholder: "2023",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "bachelors_university",
          label: "University",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "bachelors_course",
          label: "Course",
          placeholder: "Btech. Computer Science",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Masters completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "masters_cgpa",
          label: "Masters Marks",
          placeholder: "8 CGPA",
          type: InputType.CountedTextInput,
          minLength: 1,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "masters_yop",
          label: "Year of Passing",
          placeholder: "2023",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "masters_university",
          label: "University",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "masters_course",
          label: "Course",
          placeholder: "Masters Of Technology in Artifical Intelligence",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Any Gap ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "gap_time_period",
          label: "Time Duration Of Gap",
          placeholder: "2 years",
          type: InputType.CountedAutoComplete,
          minLength: 1,
          maxLength: 100,
          options: ["1 year", "2 years", "3 years"],
        },
        {
          name: "gap_explanation",
          label: "Reason for Gap",
          placeholder: "Preparing for GATE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Current Employment details(if any)",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "current_employer",
          label: "Your Current Employer",
          placeholder: "Tootler",
          type: InputType.CountedTextInput,
          minLength: 1,
          maxLength: 100,
        },
        {
          name: "period_of_employment",
          label: "Period Of Employment ",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "current_designation",
          label: "Your Current Designation",
          placeholder: "Software Engineer",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "reference_details",
          label: "Reference person details",
          placeholder: "Ankita, ankitach4650@gmail.com",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Financial situation in home country",
      type: InputType.InputCluster,
      cols: 2,
      required: true,
      fields: [
        {
          name: "father_occupation",
          label: "Father's Occupation",
          placeholder: "Business",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          required: true,
        },
        {
          name: "mother_occupation",
          label: "Mother's Occupation(if working)",
          placeholder: "Housewife",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          required: false,
        },
        {
          name: "family_income",
          label: "Annual Family Income",
          placeholder: "25000 CAD",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          required: true,
        },
        {
          name: "asset_details",
          label: "Other Asset Details",
          type: InputType.CountedTextArea,
          minLength: 2,
          maxLength: 100,
          required: false,
        },
      ],
    },

    {
      label: "Immigration History(if any)",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "countries_traveled",
          label: "Countries Traveled",
          placeholder: "Australia, Canada",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 200,
          //  description: "Please write in the format Canada, Australia, England",
        },
        {
          name: "type_of_visa",
          label: "Through which you travelled ?",
          placeholder: "Visitor visa , Tourist visa",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //   "Write in the format Visitor visa for Australia,Tourist visa for Canada",
        },
      ],
    },
  ],
};

export default formFields;
